<template>
  <main id="main">
    <Loading :isProcessing="isProcessing"></Loading>
    <div class="l-contents" v-if="!isRendering">
      <h1 class="l-pageTitle">ガイド</h1>
      <div class="l-diagnosisSearch">
        <div class="l-diagnosisSearch__header" @click="showSearch(!isSearch)">
          <p class="l-diagnosisSearch__label"><img src="@/assets/img/common/icon-search.svg" alt="">絞り込み</p>
        </div>
        <transition name="guidesearch-fade">
          <div class="l-diagnosisSearch__body" v-show="isSearch">
            <div class="l-diagnosisSearch__section">
              <label class="l-formGroup__label">ガイドコード</label>
              <div class="l-inputKeyword">
                <TextBox v-model="searchForm.guideCd" placeholder="ガイドコード" name="searchGuideCd" ></TextBox>
              </div>
            </div>
            <div class="l-diagnosisSearch__bottom">
              <div class="btn-basic is-inlne" @click="getGuideList(1)" :disabled="isProcessing"><a>絞り込む</a></div>
            </div>
          </div>
        </transition>
      </div>
      <div class="l-contentsSection">
        <input type="file" v-on:change="fileSelected">
        <div class="btn-basic is-inlne is-primary js-savebtn" @click="fileUpload()"><a>ガイドPDFアップロード</a></div>
      </div>
      <table class="table-base audit-table table-select mt-30">
        <colgroup>
          <col style="width: 20%;">
          <col style="width: 30%;">
          <col style="width: 30%;">
          <col>
          <col>
        </colgroup>
        <thead>
          <tr>
            <th>ガイドコード</th>
            <th>ファイル名</th>
            <th>アップデート日時</th>
            <th>&nbsp;</th>
            <th>&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="guide in guideList" :key="guide.guideId" style="cursor: default;">
            <td>{{ guide.guideCd }}</td>
            <td>{{ guide.filePath }}</td>
            <td>{{ $dayjs(guide.updateTs).format("YYYY/MM/DD HH:mm:ss") }}</td>
            <td>
              <button class="link-arrow" @click="download(guide.guideCd)">ダウンロード</button>
            </td>
            <td>
              <button class="link-arrow" @click="deleteGuide(guide.guideId)">削除</button>
            </td>
          </tr>
        </tbody>
      </table>
      <pagination
        :pageInfo="pageInfo"
        @change-page="emitChangePage">
      </pagination>
    </div>
  </main>
</template>

<script>
import Loading from '@/components/parts/common/Loading.vue';
import Pagination from '@/components/parts/common/Pagination.vue';
import TextBox from '@/components/parts/form/TextBox.vue';
import { saveAs } from "file-saver";

export default {
  components: {
    Loading,
    Pagination,
    TextBox,
  },
  data() {
    return {
      isProcessing: false,
      isRendering: false,
      isSearch: false,
      pageInfo: {},
      fileInfo: '',
      guideList: [
        {
          guideId: null
        }
      ],
      searchForm: {
        guideCd: '',
      },
    }
  },
  created: function() {
    this.getGuideList(1);
  },
  methods: {
    emitChangePage(page) {
      this.getGuideList(page)
    },
    showSearch(value) {
      this.isSearch = value;
    },
    async getGuideList(page) {
      this.isProcessing = true;
      this.isRendering = true;
      let res = await this.$axios.post('/ld/api/master/guide/getGuideList', {
        page: page,
        guideCd: this.searchForm.guideCd,
      });
      if (res) {
        this.guideList = res.data.guideList.data;
        this.pageInfo = {
          currentPage: res.data.guideList.current_page,
          lastPage: res.data.guideList.last_page,
          total: res.data.guideList.total,
          from: res.data.guideList.from,
          to: res.data.guideList.to,
        };
        this.isSearch = false;
      }
      this.$nextTick(() => {
        this.isRendering = false;
        this.isProcessing = false;
      });
    },
    fileSelected(event) {
      this.fileInfo = event.target.files[0];
    },
    async fileUpload() {
      this.isProcessing = true;
      if (!this.fileInfo) {
        this.$toast.error("ファイルを選択してください");
        this.isProcessing = false;
        return;
      }
      const formData = new FormData();
      formData.append('file', this.fileInfo);
      let res = await this.$axios.post('/ld/api/master/guide/upload', formData);
      if (res.status === 200) {
        this.$toast.info('登録が完了しました');
        this.getGuideList(1);
      } else {
        this.$toast.error(res.data.message);
      }
      this.fileInfo = '';
      this.isProcessing = false;
    },
    async deleteGuide(guideId) {
      const answer = window.confirm("削除しますか？");
      if (answer) {
        this.isProcessing = true;
        let res = await this.$axios.post('/ld/api/master/guide/delete', {
          guideId: guideId,
        });
        if (res.status === 200) {
          this.$toast.info('削除しました');
          this.getGuideList(1);
        } else {
          this.$toast.error(res.data.message);
        }
        this.isProcessing = false;
      }
    },
    async download(guideCd) {
      await saveAs('/ld/api/master/guide/downloadByGuideCd?guideCd=' + guideCd);
    },
  },
}

</script>

<style scoped>
.guidesearch-fade-enter-active {
  transition: height .1s ease-in-out;
}
.guidesearch-fade-leave-active {
  transition: height .1s ease-in-out;
}
.guidesearch-fade-enter-to, .guidesearch-fade-leave {
  overflow: hidden;
}
.guidesearch-fade-enter, .guidesearch-fade-leave-to {
  overflow: hidden;
}
</style>
